/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type GetInsightsSectionsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetInsightsSectionsQuery = {
  __typename?: 'Query';
  getInsightsHeroArticles?: {
    __typename?: 'InsightsArticlesCollection';
    articles?: Array<{
      __typename?: 'InsightsArticle';
      objectUrn?: string | null;
      readingTime?: number | null;
      category?: string | null;
      bgColor?: string | null;
      details?: {
        __typename?: 'InsightsArticleDetails';
        title?: string | null;
        url?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'InsightsArticleImage';
          srcSquare?: string | null;
          srcSquare2x?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  getInsightsJobSearchArticles?: {
    __typename?: 'InsightsArticlesCollection';
    articles?: Array<{
      __typename?: 'InsightsArticle';
      objectUrn?: string | null;
      readingTime?: number | null;
      category?: string | null;
      bgColor?: string | null;
      details?: {
        __typename?: 'InsightsArticleDetails';
        title?: string | null;
        url?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'InsightsArticleImage';
          srcSquare?: string | null;
          srcSquare2x?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  getInsightsSalaryArticles?: {
    __typename?: 'InsightsArticlesCollection';
    articles?: Array<{
      __typename?: 'InsightsArticle';
      objectUrn?: string | null;
      readingTime?: number | null;
      category?: string | null;
      bgColor?: string | null;
      details?: {
        __typename?: 'InsightsArticleDetails';
        title?: string | null;
        url?: string | null;
        description?: string | null;
        image?: {
          __typename?: 'InsightsArticleImage';
          srcSquare?: string | null;
          srcSquare2x?: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export const GetInsightsSectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getInsightsSections' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getInsightsHeroArticles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InsightsArticle' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getInsightsJobSearchArticles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InsightsArticle' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getInsightsSalaryArticles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'articles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'InsightsArticle' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'InsightsArticle' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'InsightsArticle' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'objectUrn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'readingTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bgColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'details' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'srcSquare' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'srcSquare2x' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetInsightsSectionsQuery,
  GetInsightsSectionsQueryVariables
>;
